export default __webpack_public_path__ + "static/media/external.16e45696.svg";